'use es6';

import { FORM_DASHBOARD_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Forms = ObjectDefinitionRecord({
  hasAccess: () => true,
  objectTypeId: FORM_DASHBOARD_TYPE_ID,
  referenceObjectType: 'FORM_PROPERTIES'
});
export default Forms;